import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, message, Upload } from "antd";
import { UploadProps } from "antd/lib";
import { ReactElement } from "react";
import { useParams } from "react-router-dom";
import { useGetApplicationDataToBankQuery } from "../../../../store/api/applicationBankApi/applicationBank.api";
import { useUploadAdditionalDocumentMutation } from "../../../../store/api/applicationBankApi/documents.api";
import {
  APPLICATION_BANK_STATUS_KKB,
  BANK_NAME,
} from "../../../../utils/guards/ApplicationBankStatusGuard/types";
import { Guard } from "../../../../utils/guards/Guard";
import { validateFile } from "../../../../utils/utilities/validateFile";
import { ApplicationDetailsAdditionalDocSection } from "./ApplicationDetailsAdditionalDocSection/ApplicationDetailsAdditionalDocSection";
import { ApplicationDetailsDocSection } from "./ApplicationDetailsDocSection/ApplicationDetailsDocSection";

import classes from "./ApplicationDetailsDocList.module.css";

export function ApplicationDetailsDocList(): ReactElement {
  const { applicationId, applicationBankId } = useParams();

  const { data: applicationBankData } = useGetApplicationDataToBankQuery({
    applicationId: Number(applicationId),
    applicationBankId: Number(applicationBankId),
  });

  const passportDocument = applicationBankData?.documents.pasportDocument;

  const financeDocument = applicationBankData?.documents.financeDocument;
  const banksOfferDocuments =
    applicationBankData?.documents.banksOfferDocuments;
  const additionalDocument = applicationBankData?.documents.additionalDocument;
  applicationBankData?.documents.banksOfferDocuments;

  const [uploadDocument, { isLoading: isDocumentLoading }] =
    useUploadAdditionalDocumentMutation();

  const formFileData = new FormData();

  const props: UploadProps = {
    showUploadList: false,
    beforeUpload: (file) => {
      const { isValidate, error } = validateFile(file);
      if (isValidate) {
        formFileData.append("type_doc_id", `10`);
        formFileData.append("file", file);
        uploadDocument({
          applicationBankId: Number(applicationBankId),
          applicationId: Number(applicationId),
          body: formFileData,
          section: "additionalDocument",
        });
      } else {
        message.error(error);
      }
      return false;
    },
  };

  return (
    <div
      style={{ paddingBottom: "24px", cursor: "pointer" }}
      className={classes.appDetailsDocWrapper}
    >
      {banksOfferDocuments && banksOfferDocuments?.documents.length > 0 && (
        <>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.appDetailsDocListDivider}
          >
            {banksOfferDocuments.title}
          </Divider>
          <ApplicationDetailsDocSection
            applicationBankStatus={applicationBankData.status.type}
            documents={banksOfferDocuments.documents}
            section={"pasportDocument"}
          />
        </>
      )}
      {passportDocument && passportDocument.documents.length > 0 && (
        <>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.appDetailsDocListDivider}
          >
            {passportDocument.title}
          </Divider>
          <ApplicationDetailsDocSection
            applicationBankStatus={applicationBankData.status.type}
            documents={passportDocument.documents}
            section={"pasportDocument"}
          />
        </>
      )}

      {financeDocument && financeDocument.documents.length > 0 && (
        <>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.appDetailsDocListDivider}
          >
            {financeDocument.title}
          </Divider>
          <ApplicationDetailsDocSection
            applicationBankStatus={applicationBankData.status.type}
            documents={financeDocument.documents}
            section={"financeDocument"}
          />
        </>
      )}
      {additionalDocument && (
        <>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.appDetailsDocListDivider}
          >
            {additionalDocument.title}
          </Divider>
          <ApplicationDetailsAdditionalDocSection
            documents={additionalDocument.documents}
            section={"additionalDocument"}
            status={applicationBankData.status || "dfsdf"}
          />
        </>
      )}

      {applicationBankData && (
        <Guard.ApplicationBankStatus
          status={applicationBankData.status}
          allowedStatuses={[
            {
              bank_name: BANK_NAME.KKB,
              type: APPLICATION_BANK_STATUS_KKB.REVISION,
            },
            {
              bank_name: BANK_NAME.KKB,
              type: APPLICATION_BANK_STATUS_KKB.PROCESSING,
            },
          ]}
        >
          <Upload {...props}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              style={{ marginBottom: "24px" }}
              loading={isDocumentLoading}
            >
              Добавить дополнительные документы
            </Button>
          </Upload>
        </Guard.ApplicationBankStatus>
      )}
    </div>
  );
}
